// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2buTx","tab":"ProcedureTabs_tab__3Xb5E"};